export enum ModuloMenuSistemaEnum {
  Bilhetagem_Administrativo = 1,
  Bilhetagem_Cadastro = 2,
  //Bilhetagem_Financeiro = 3,
  //Bilhetagem_Contabilidade = 4,
  Bilhetagem_Prestação = 5,
  Bilhetagem_Aprovação = 6,
  Bilhetagem_Relatórios = 7,
  Bilhetagem_Segurança = 8,
  'Bilhetagem_(VT)Relatórios' = 10,
  Bilhetagem_VT = 11,
  Loja_Caixa = 101,
  Loja_Contas = 102,
  Loja_Contestação = 103,
  Loja_Benefícios = 104,
  Loja_Recarga = 105,
  Administrativo_Gestão_Usuários = 201,
  Administrativo_Cadastro = 202,
  Administrativo_Contabilidade = 203,
  Administrativo_Financeiro = 204,
  Administrativo_Relatórios = 205,
  Tiqueteira_Cadastro = 301,
  Tiqueteira_Recarga = 302,
  Tiqueteira_Relatórios = 303,
  CaixaTem_Caixa_Tem = 401,
  AppPrestacaoContas_Prestação_Contas = 501,
  SemModulo = 1000000,
}

export const ModuloMenuSistemaCodigoDescricao = Object.keys(
  ModuloMenuSistemaEnum
).map((key: any) => ({
  codigo: ModuloMenuSistemaEnum[key],
  descricao: key,
}));
